import { useEffect } from 'react';
import { useFetchedContentSession } from './useFetchedSessionContent';
import { useStores } from '../useStores';

interface SessionData {
  pathId?: string | null;
  sessionId?: string;
  fromPath?: boolean;
  reckoningId?: string;
  fromReckoning?: boolean;
}

export const useSession = ({
  pathId,
  sessionId,
  fromPath,
  reckoningId,
  fromReckoning,
}: SessionData) => {

  const { session: sessionStore, language, user, path: pathStore } = useStores();
  console.log('useSession', {
    pathId,
    sessionId,
    fromPath,
    reckoningId,
    fromReckoning,
  });
  const session = sessionId ? sessionStore.getSessionInfo(
    pathId || null,
    sessionId
  ) : undefined;
  const path = pathStore.getPath(pathId as string);

  const {loading: contentLoading, error: contentError, fetchWithFrames, fetch } = useFetchedContentSession(session!);

  // always refresh on entry: the session store is persisted across runs, and a
  // stale copy would keep steps (e.g. their activity ids) the server changed
  useEffect(() => {
    if(user?.user) {
      if (sessionId && pathId && fromPath) {
        sessionStore.fetchSessionWrapperIfNotExistFromPath(sessionId, pathId, true, true);
      } else if (sessionId) {
        if(reckoningId && fromReckoning) {
          sessionStore.fetchSessionWrapperIfNotExistFromReckoning(sessionId,reckoningId, true, true);
        } else {
          sessionStore.fetchSessionWrapperIfNotExistIndependent(sessionId, true, true);
        }
      }
    }
  }, [user.user, language?.language]);

  useEffect(()=> {
    if (user?.user && session && path?.language) {
      fetchWithFrames(pathId || undefined);
    } else if (user?.user && session) {
      fetch();
    }
  }, [!!session, user?.user, path?.language]);

  return {
    loading: sessionStore.state === 'pending' || contentLoading,
    error: sessionStore.state === 'error' || contentError,
  };
};